<template>
    <div class="main">
        <div ref="container" class="container">
            <headerWX class="headerWX"></headerWX>

            <!-- 每日任务and筛子 -->
            <div class="dailyTask">
                <div class="dailyTask-top">
                    <div class="tit">
                        <img src="@/assets/imgs/ThrowingGame/dailyTask-top-tit.png" alt="" />
                    </div>
                    <img class="bg" src="@/assets/imgs/ThrowingGame/dailyTask-top.png" alt="" />
                    <div class="dailyTask-top-boby">
                        <div class="text" v-for="(item, index) in getActivityList.dailyTasks" :key="index">
                            <span class="taskDesc" style="width: 50%">{{ item.taskDesc }}</span>

                            <!-- <span style="width: 22%;">{{ item.processTxt }}</span> -->
                            <span class="award">
                                <img style="vertical-align: middle" src="@/assets/imgs/ThrowingGame/dice.png" alt="" />
                                x {{ item.rewardDiceCount }}
                            </span>

                            <div>
                                <img v-if="item.status == 1" :src="addTaskright1" @click="receive(item, 1)" alt="" />
                                <img v-else-if="item.status == 0 && item.jumpUrl != ''" :src="addTaskright2"
                                    @click="goShop(item)" alt="" />
                                <img v-else-if="
                                    item.status == 0 &&
                                    item.jumpUrl == '' &&
                                    item.btnText == '领取'
                                " :src="addTaskright1" alt="" style="filter: grayscale(100%)" />
                                <img v-else :src="addTaskright3" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dailyTask-bottom">
                    <div class="dailyTask-bottom-left">
                        <img src="@/assets/imgs/ThrowingGame/dailyTask-bottom-left.png" alt="" />
                        <div class="left_boby">
                            <div class="left_boby1">{{ getActivityList.diceCount }}</div>
                            <div class="left_boby1">{{ getActivityList.usedDiceCount }}</div>
                            <div class="left_boby1">{{ getActivityList.totalDiceCount }}</div>
                        </div>
                    </div>
                    <div class="dailyTask-bottom-right">
                        <!-- <img @click="goisSee(2)" src="@/assets/imgs/ThrowingGame/dailyTask-bottom-right-left.png"
                            alt="" /> -->
                        <img @click="goisSee(2)" src="@/assets/imgs/ThrowingGame/dailyTask-bottom-right-left.png"
                            alt="" />
                        <img @click="gobuyShop" src="@/assets/imgs/ThrowingGame/dailyTask-bottom-right-right.png"
                            alt="" />
                    </div>
                </div>
            </div>

            <!-- 游戏 -->
            <div class="game">
                <img src="@/assets/imgs/ThrowingGame/game-bg.png" alt="" />
                <div class="game-btn" v-if="!isDice">
                    <img @click.stop="go" src="@/assets/imgs/ThrowingGame/game-btn.png" alt="" />
                    <el-checkbox v-model="skip">跳过动画</el-checkbox>
                </div>
                <div class="game-num">
                    <img src="@/assets/imgs/ThrowingGame/game-num.png" alt="" />
                    <div class="num"> X {{ getActivityList.diceCount }}</div>
                </div>
                <!-- <div class="game_goShop" @click="gobuyShop">
                    <img src="@/assets/imgs/ThrowingGame/goShop.png" alt="">
                </div> -->

                <div class="renwu" v-if="!init" :style="{
                    '--top': CSYS[CSYSIndex - 1].x + '%',
                    '--left': CSYS[CSYSIndex - 1].y + '%',
                    backgroundImage: 'url(' + headPortrait + ')',
                    backgroundSize: '100% 100%',
                }" style="
            background: url('../../assets/imgs/ThrowingGame/headPortrait.png');
          "></div>
                <div class="game_describe_boby">
                    <div class="game_describe" :style="{
                        '--top': CSYS[index].x + '%',
                        '--left': CSYS[index].y + '%',
                    }" v-for="(value, index) in CSYS" :key="index">
                        <el-tooltip :content="getActivityList.rewardConfigs[index].rewardDesc" placement="top">
                            <img :src="getActivityList.rewardConfigs[index].itemImg" alt="">
                        </el-tooltip>
                    </div>
                </div>

                <div class="firstTime">
                    <img class="bg" src="@/assets/imgs/ThrowingGame/firstTimeBg.png" alt="">
                    <div class="con">
                        <p class="text">{{ getActivityList.firstCompletionReward.rewardName }}</p>
                        <img class="btn" v-if="getActivityList.firstCompletionRewardStatus == 0"
                            src="@/assets/imgs/ThrowingGame/notFirstTime.png" alt="">
                        <img class="btn" @click="goShop_pop(1)"
                            v-else-if="getActivityList.firstCompletionRewardStatus == 1"
                            src="@/assets/imgs/ThrowingGame/firstTime.png" alt="">
                        <img class="btn" v-else src="@/assets/imgs/ThrowingGame/yesFirstTime.png" alt="">
                    </div>

                </div>
            </div>
            <!-- 首次完成奖励 -->
            <!-- <div class="firstTime">
                <img src="@/assets/imgs/ThrowingGame/firstTime_bg.png" alt="" />
                <div class="firstTime_body">
                    <div class="firstTime_body_tit">{{ getActivityList.firstCompletionReward.rewardName }}</div>
                    <div class="firstTime_body_con">
                        <img class="btn" v-if="getActivityList.firstCompletionRewardStatus == 0"
                            style="filter: grayscale(100%);" src="@/assets/imgs/ThrowingGame/addTask_btn1.png" alt="" />
                        <img class="btn" @click="goShop_pop(1)"
                            v-else-if="getActivityList.firstCompletionRewardStatus == 1"
                            src="@/assets/imgs/ThrowingGame/addTask_btn1.png" alt="" />
                        <img class="btn" v-else src="@/assets/imgs/ThrowingGame/addTask_btn3.png" alt="" />
                    </div>
                </div>
            </div> -->

            <!-- 仙露商店 -->
            <div class="shop">
                <div style="text-align: center; margin-bottom: 25px">
                    <img src="@/assets/imgs/ThrowingGame/shop_tit1.png" alt="" />
                </div>
                <div style="width: 70%; margin: 0 auto; position: relative">
                    <div class="completionCount">
                        拥有仙露数量：{{ getActivityList.xianLuBalance }}
                    </div>
                    <div class="shop_boby">
                        <div v-for="(item, index) in getActivityList.shopItems" :key="index">
                            <div class="shop_item">
                                <div class="text">需消耗仙露：{{ item.price }}</div>
                                <div class="imgItem">
                                    <el-tooltip :content="item.itemDesc" placement="top">
                                        <img :src="item.itemImg" alt="" />
                                    </el-tooltip>

                                    <!-- <img src="https://www.toopic.cn/public/uploads/small/1755068280232175506828072.png"> -->
                                </div>
                                <div class="awardName">{{ item.itemName }}</div>
                            </div>
                            <div class="shop_btn">
                                <!-- <img v-if="item.isClaimed == true" src="@/assets/imgs/ThrowingGame/shop_btn1.png" />
                                <img v-else-if="item.canClaim == false" style="filter: grayscale(100%);"
                                    src="@/assets/imgs/ThrowingGame/shop_btn.png" />
                                <img v-else-if="item.canClaim == true" src="@/assets/imgs/ThrowingGame/shop_btn.png"
                                    @click="goShop_pop(2, item)" alt="" /> -->

                                <img v-if="item.limitCount === 0 || item.buyCount < item.limitCount"
                                    src="@/assets/imgs/ThrowingGame/duihuan.png" @click="xianluduihuanBoxFun(item)"
                                    alt="" />
                                <img v-else src="@/assets/imgs/ThrowingGame/yiduihuan.png" />
                                <div style="color: #fff;" v-if="item.limitCount != 0">
                                    ({{ item.buyCount ? item.buyCount : 0 }}/{{ item.limitCount
                                    }})</div>
                                <!-- <div style="color: #000000;">({{ item.goodsIntro}})
                            </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- 精品商店 -->
            <div class="shop">
                <div style="text-align: center; margin-bottom: 25px">
                    <img src="@/assets/imgs/ThrowingGame/shop_tit.png" alt="" />
                </div>
                <div style="width: 70%; margin: 0 auto; position: relative">
                    <div class="completionCount">
                        已完成圈数：{{ getActivityList.completionCount }}
                    </div>
                    <div class="shop_boby">
                        <div v-for="(item, index) in getActivityList.peakRewardConfigs" :key="index">
                            <div class="shop_item">
                                <div class="text">需完成圈数：{{ item.completionCount }}</div>
                                <div class="imgItem">
                                    <el-tooltip :content="item.rewardDesc" placement="top">
                                        <img :src="item.itemImg" alt="" />
                                    </el-tooltip>

                                    <!-- <img src="https://www.toopic.cn/public/uploads/small/1755068280232175506828072.png"> -->
                                </div>
                                <div class="awardName">{{ item.rewardName }}</div>
                            </div>
                            <div class="shop_btn">
                                <img v-if="item.isClaimed == true" src="@/assets/imgs/ThrowingGame/shop_btn1.png" />
                                <img v-else-if="item.canClaim == false" style="filter: grayscale(100%);"
                                    src="@/assets/imgs/ThrowingGame/shop_btn.png" />
                                <img v-else-if="item.canClaim == true" src="@/assets/imgs/ThrowingGame/shop_btn.png"
                                    @click="goShop_pop(2, item)" alt="" />
                                <!-- <div style="color: #fff;">({{ item.buyCount ? item.buyCount : 0 }}/{{ item.limitCount }}) -->
                                <!-- <div style="color: #000000;">({{ item.goodsIntro}})
                            </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 骰子蒙层 -->
            <div id="mask" v-if="isDice">
                <div class="shake" style="
            height: 100px;
            width: 50rem;
            z-index: 100;
            position: fixed;
            top: 30%;
            left: 50%;
            transform: translate(-50%, -50%);
          ">
                    <dice ref="diceref" isDice :diceResult="diceResult" @refgain="gain"></dice>
                </div>
            </div>

            <!-- 排行榜and规则 -->
            <div id="mask" v-if="isSee">
                <div class="shake" style="
            height: 700px;
            width: 600px;
            z-index: 100;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          ">
                    <see :closeisSee="closeisSee" :SeeData="SeeData" :isSeeIndex="isSeeIndex" @recur="recur"
                        @quits="quit"></see>
                </div>
            </div>
        </div>

        <!-- <div class="chufa" @click="go" v-if="!isDice">
            出发
        </div> -->
    </div>
</template>

<script>
import axios from "axios";
import Cookies from "js-cookie";
import Dice from "../ThrowingGame/compon/dice.vue";
import see from "./compon/see.vue";
import headerWX from "@/components/ActivityHeader/header.vue";

import {
    getActivityListApi,
    getActivityInfoApi,
    getDailyTaskApi,
    startGameApi,
    getPeakRewardApi,
    buyShopItemApi
} from "@/api/Throwinggame/index";
export default {
    name: "ThrowingGame",
    components: {
        Dice,
        see,
        headerWX,
    },
    data() {
        return {
            addList: [],
            addTaskright1: require("@/assets/imgs/ThrowingGame/addTask_btn1.png"),
            addTaskright2: require("@/assets/imgs/ThrowingGame/addTask_btn2.png"),
            addTaskright3: require("@/assets/imgs/ThrowingGame/addTask_btn3.png"),
            headPortrait: require("@/assets/imgs/ThrowingGame/headPortrait.png"),
            CSYS: [
                { x: 2, y: 5.8 },
                { x: 2, y: 19.6 },
                { x: 2, y: 33.4 },

                { x: 16.4, y: 33.4 },
                { x: 16.4, y: 47 },
                { x: 16.4, y: 60.7 },

                { x: 2, y: 60.7 },
                { x: 2, y: 74.4 },
                { x: 2, y: 88.2 },

                { x: 16.4, y: 88.2 },
                { x: 30.7, y: 88.2 },
                { x: 30.7, y: 74.6 },

                { x: 45, y: 74.6 },
                { x: 59.2, y: 74.6 },
                { x: 59.2, y: 88.3 },
                { x: 73.5, y: 88.2 },

                { x: 87.6, y: 88.2 },
                { x: 87.6, y: 74.4 },
                { x: 87.6, y: 60.7 },
                { x: 87.6, y: 47 },
                { x: 87.6, y: 33.4 },
                { x: 87.6, y: 19.7 },
                { x: 87.6, y: 6 },
                { x: 73.5, y: 6 },

                { x: 59, y: 6 },
                { x: 45, y: 6 },
                { x: 45, y: 19.7 },

                { x: 45, y: 33.4 },
                { x: 59.3, y: 33.4 },
                { x: 59.3, y: 47 },
                // { x: 40.6, y: 47.4 },
            ],
            init: true, //是否展示 头像
            CSYSIndex: 0, // 当前位置 第几个格子

            isDice: false,
            isSee: false,
            isSeeIndex: 1,
            // 骰子结果
            diceResult: 0,
            // 骰子奖励
            SeeData: {},

            // 骰子活动信息
            getActivityList: {},
            // 用户信息
            userInfo: {},
            // 圈数
            cyclomaticNumber: 0,
            skip: false, // 是否跳过

            // 加载
            loading: null
        };
    },
    created() {
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));

        // 每日任务，追加任务
        this.everydayAddList();
    },
    mounted() { },

    methods: {
        gobuyShop() {
            window.open(this.getActivityList.buyLink);
        },

        // 每日任务，追加任务
        async everydayAddList() {
            this.loading = this.$loading({
                // lock: true,
                text: '加载中请稍后....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            await getActivityInfoApi({
                activityName: "20260923_dice_activity",
                userId: Cookies.get("cwsl_userId"), // userId
                platForm: "web",
            })
                .then((res) => {
                    if (res.data.state == 200) {
                        this.CSYSIndex = res.data.data.currentPosition;
                        this.getActivityList = res.data.data;
                        if (res.data.data.currentPosition == 0) {
                            this.init = true;
                        } else {
                            this.init = false;
                        }
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                })
                .finally(() => {
                    this.loading.close()
                });
        },

        // 骰子出发
        go() {
            this.loading = this.$loading({
                // lock: true,
                text: '请稍后....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            startGameApi({
                activityName: "20260923_dice_activity",
                userId: Cookies.get("cwsl_userId"), // userId
                platForm: "web",
            })
                .then(({ data }) => {
                    if (data.state == 200) {
                        this.diceResult = data.data.diceResult;
                        this.SeeData = {
                            prizeName: data.data.rewardName,
                            prizeNum: data.data.rewardItemNum,
                        };
                        if (this.skip) {
                            this.isDice = false;
                            this.goisSee(3);
                            this.everydayAddList();
                        } else {
                            this.isDice = true;
                            setTimeout(() => {
                                this.everydayAddList();
                            }, 3000);
                        }

                    } else {
                        this.$message.error(data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                })
                .finally(() => {
                    this.loading.close()
                });
            // this.diceResult = 2;
            // this.SeeData = {
            //     prizeName: '测试', prizeNum: 2
            // };
            // this.isDice = true;
        },

        // 排行榜
        goisSee(index) {
            this.isSeeIndex = index;
            this.isSee = true;
        },
        // 关闭排行榜
        closeisSee() {
            this.isSee = false;
            this.isDice = false;
        },

        // 获得筛子
        gain() {
            setTimeout(() => {
                this.isDice = false;
                this.goisSee(3);
            }, 1500);
        },
        // 退出
        quit() {
            this.isDice = false;
            this.isSee = false;
        },
        // 再来一次
        recur({type,item}) {
            if (type == 3) {
              // 关闭奖励通知
            this.isSee = false;
            // 再次开始
            this.go();  
            }else if (type == 4) {
                this.xianluduihuanFun(item)
            }
            
        },

        // 领取奖励
        async receive(item, type) {

            this.loading = this.$loading({
                // lock: true,
                text: '领取中请稍后....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            await getDailyTaskApi({
                activityName: "20260923_dice_activity",
                taskId: item.taskId,
                userId: Cookies.get("cwsl_userId"), // userId
                platForm: "web",
            })
                .then(({ data }) => {
                    if (data.state == 200) {
                        this.$message.success(data.message);
                        this.everydayAddList();
                    } else {
                        this.$message.error(data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                })
                .finally(() => {
                    this.loading.close()
                });
        },
        // 点击商品跳转到商品详情
        goShop(item) {
            if (item.jumpUrl.indexOf("http") != -1) {
                window.open(item.jumpUrl, "_blank");
            } else {
                this.$router.push({
                    path: item.jumpUrl,
                });
            }
        },


        // 兑换二次弹窗
        xianluduihuanBoxFun(item){
            this.isSeeIndex = 4;
            this.SeeData = item
            
            this.isSee = true;
        },
        //仙露兑换
        async xianluduihuanFun(item) {
            
            this.loading = this.$loading({
                // lock: true,
                text: '兑换中请稍后....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            await buyShopItemApi({
                activityName: "20260923_dice_activity",
                itemId: item.itemId,
                userId: Cookies.get("cwsl_userId"), // userId
                platForm: "web",
            }).then((res) => {
                if (res.data.state == 200) {
                    this.$message.success('兑换成功');
                    this.quit()
                    this.everydayAddList();
                } else {
                    this.$message.error(res.data.message);
                }
            })
                .catch((err) => {
                    this.$message.error(err.message);
                })
                .finally(() => {
                    this.loading.close()
                });
        },


        async goShop_pop(type, item) {
            await getPeakRewardApi({
                activityName: "20260923_dice_activity",
                rewardItemId: type == 1 ? 99 : item.rewardItemId,
                userId: Cookies.get("cwsl_userId"), // userId
                platForm: "web",
            })
                .then((res) => {
                    if (res.data.state == 200) {
                        this.$message.success(res.data.message);
                        this.everydayAddList();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                });
        },
    },
};
</script>

<style lang="less" scoped>
.headerWX {
    // margin: 0;
    // position: absolute;
    // top: 50px;
    // left: 50%;
    // transform: translateX(-50%);

    /deep/ .header {
        // background: rgba(0, 97, 27, 0.8);
    }
}

body {
    margin: 0;
    padding: 0;
}

.main {
    width: 100%;
    min-width: 1200px;
    position: relative;
    /* 标准语法 */
    background: linear-gradient(181deg, #5acaf0 0%, #bce748 50%, #72b731 100%);
    /* 浏览器兼容性处理 */
    background: -webkit-linear-gradient(181deg,
            #5acaf0 0%,
            #bce748 50%,
            #72b731 100%);
    background: -moz-linear-gradient(181deg,
            #5acaf0 0%,
            #bce748 50%,
            #72b731 100%);
    background: -ms-linear-gradient(181deg,
            #5acaf0 0%,
            #bce748 50%,
            #72b731 100%);
    background: -o-linear-gradient(181deg, #5acaf0 0%, #bce748 50%, #72b731 100%);
    // display: flex;
    // justify-content: center;
}

.container {
    margin: 0 auto;
    max-width: 2000px;
    // min-height: 4245px;
    background-color: #fff;
    overflow: hidden;
    background-image: url("../../assets/imgs/ThrowingGame/bg.png");
    background-size: 100%;
    /* margin-top: 50px; */
    // min-width: 99.5vw;

    .dailyTask {
        // height: 1000px;
        width: 60%;
        margin: 0 auto;
        margin-top: 10px;

        .dailyTask-top {
            width: 100%;
            position: relative;

            .tit {
                width: 100%;
                display: flex;
                justify-content: center;

                >img {
                    width: 35%;
                }
            }

            .bg {
                width: 100%;
            }

            .dailyTask-top-boby {
                width: 80%;
                height: 56%;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 46px;

                .text {
                    width: 100%;
                    height: 49%;
                    display: flex;
                    align-items: center;

                    span {
                        display: inline-block;
                        font-weight: 500;
                        font-size: 25px;
                        color: #333333ff;
                        text-shadow: 0px 1px 1px rgba(0, 95, 49, 0.3);
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }

                    .taskDesc {
                        width: 50%;
                    }

                    .award {
                        width: 25%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        gap: 10px;
                    }

                    >div {
                        width: 25%;
                        height: 100%;
                        // display: inline-block;
                        float: right;

                        img {
                            position: relative;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                }
            }
        }

        .dailyTask-bottom {
            width: 100%;
            margin-top: 4%;
            // height: 260px;
            display: flex;

            .dailyTask-bottom-left {
                width: 77%;
                height: 100%;
                // margin-right: 2%;
                // background-image: url("../../assets/imgs/ThrowingGame/dailyTask-bottom-left.png");
                // background-size: 100% 100%;
                position: relative;

                >img {
                    width: 100%;
                }

                .left_boby {
                    width: 100%;
                    height: 40%;
                    position: absolute;
                    bottom: 2px;
                    display: flex;

                    .left_boby1 {
                        color: #c5492d;
                        text-align: center;
                        font-size: 38px;
                        font-weight: bolder;
                        width: 33%;
                        height: 100%;
                        // background-color: #004E1F;
                    }
                }
            }

            .dailyTask-bottom-right {
                // width: 20%;
                flex: 1;
                display: flex;
                align-items: flex-end;

                img {
                    margin-top: 2%;
                    // height: 230px;
                    width: 48%;
                }

                img:nth-child(1) {
                    margin-right: 4%;
                }
            }
        }
    }

    .game {
        width: 73%;
        // height: 1350px;
        margin: 0 auto;
        margin-top: 65px;
        // background-image: url("../../assets/imgs/ThrowingGame/game-bg.png");
        // background-size: 100% 100%;
        position: relative;

        >img {
            width: 100%;
        }

        .game-btn {
            position: absolute;
            top: 35%;
            left: 50%;
            transform: translate(-50%, -50%);
            cursor: pointer;
            z-index: 100;
            width: 30%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            >img {
                width: 80%;
            }

            /deep/.el-checkbox__inner {
                border-radius: 50% !important;
            }
        }

        .game-num {
            position: absolute;
            top: 49%;
            left: 59%;
            transform: translate(-50%, -50%);
            width: 23%;

            // height: 155px;
            // background-image: url("../../assets/imgs/ThrowingGame/game-num.png");
            // background-size: 100% 100%;
            >img {
                width: 100%;
            }

            .num {
                position: absolute;
                width: 35%;
                text-align: center;
                top: 50%;
                left: 76%;
                transform: translate(-50%, -50%);
                font-size: 1.5em;
                color: #c5492d;
            }
        }

        .game_goShop {
            position: absolute;
            top: 54%;
            left: 55%;
            transform: translate(-50%, -50%);
            cursor: pointer;
            width: 15%;

            >img {
                width: 100%;
            }
        }

        .firstTime {
            position: absolute;
            bottom: 17%;
            left: 50%;
            transform: translateX(-50%);
            width: 70%;
            max-width: 480px;

            .bg {
                width: 100%;
            }

            .con {
                position: absolute;
                right: 0;
                top: 0;
                height: 100%;
                width: 58%;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .text {
                    padding: 0 2px;
                    font-size: 14px;
                    font-weight: 700;
                    color: #9D4839;
                }

                .btn {
                    width: 38%;

                }
            }

            // .text {
            //     position: absolute;
            //     right: 27%;
            //     top: 10%;
            // }

            // .btn {
            //     width: 26%;
            //     position: absolute;
            //     right: 0;
            //     top: 10px;
            // }
        }
    }

    // 首次完成奖励
    // .firstTime {
    //     width: 45%;
    //     margin: 0 auto;
    //     margin-top: 30px;
    //     position: relative;

    //     >img {
    //         width: 100%;
    //     }

    //     .firstTime_body {
    //         position: absolute;
    //         top: 50%;
    //         left: 50%;
    //         transform: translate(-50%, -50%);
    //         width: 88%;
    //         height: 48%;
    //         display: flex;
    //         align-items: center;
    //         justify-content: space-around;

    //         .firstTime_body_tit {
    //             font-size: 20px;
    //             font-weight: 700;
    //         }

    //         .firstTime_body_con {
    //             max-width: 20%;

    //             >img {
    //                 width: 100%;
    //             }
    //         }
    //     }
    // }

    #mask {
        width: 100vw;
        height: 100vh;
        // opacity: 0.6;
        background-color: rgba(0, 0, 0, 0.8);
        bottom: 0;
        left: 0;
        position: fixed;
        z-index: 999;
    }

    .shop {
        margin-top: 50px;
        margin-bottom: 60px;

        // width: 20%;
        .completionCount {
            // color: #c84c30;
            font-size: 23px;
            font-weight: 600;
            width: 100%;
            text-align: center;
            margin-bottom: 20px;
            color: #fff;
            text-shadow: -1px -1px 0 #c84c30, 1px -1px 0 #c84c30,
                -1px 1px 0 #c84c30, 1px 1px 0 #c84c30;
        }

        .shop_boby {
            display: flex;
            // justify-content: space-between;
            justify-content: center;
            gap: 25px;

            // height: 300px;
            >div {
                width: 18%;
            }

            .shop_item {
                width: 100%;
                height: 250px;
                background-image: url("../../assets/imgs/ThrowingGame/shop_baby.png");
                background-size: 100% 100%;
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: center;

                .text {
                    width: 75%;
                    height: 24%;
                    // border-bottom: 1px solid #f2b474;

                    text-align: center;
                    line-height: 80px;
                    font-weight: 500;
                    // font-size: 18px;
                    color: #c84c30;
                    text-shadow: 0px 1px 1px rgba(0, 95, 49, 0.3);
                    font-style: normal;
                    text-transform: none;
                }

                .imgItem {
                    width: 75%;
                    height: 45%;

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        max-width: 100%;
                        max-height: 80%;
                    }
                }

                .awardName {
                    width: 75%;
                    height: 24%;

                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 600;
                }
            }

            .shop_btn {
                width: 100%;
                // height: 25%;
                text-align: center;
                position: relative;
                // bottom: 16px;
                margin-top: 14px;

                img {
                    width: 80%;
                    height: 80%;
                }
            }
        }
    }
}

/*  body {
        background-image: url("https://marketplace.canva.cn/EADfD7XfLtI/1/0/1600w/canva-%E5%BD%A9%E8%99%B9%E8%89%B2%E6%B8%90%E5%8F%98%E8%83%8C%E6%99%AF-fPoULTjoVI0.jpg");
     } */

.chufa {
    position: absolute;
    bottom: 30px;
    right: 50px;
    background-color: #a02727;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    font-size: 24px;
    text-align: center;
    line-height: 100px;
    background: url("https://ts1.cn.mm.bing.net/th/id/R-C.a9e2e1647e44a9cabd9528af30e43afb?rik=LmcvvBhKmZPw0g&riu=http%3a%2f%2fwx1.sinaimg.cn%2flarge%2f415f82b9ly1fwcoidfb1ag203w04sqa7.gif&ehk=0lLsn%2fMg1y65GYl1X2FLr4buUSXbBzCeya%2bfU6X%2bHOA%3d&risl=&pid=ImgRaw&r=0");
    background-size: 100% 100%;
}

@keyframes shake_2 {
    0% {
        transform: translateX(0);
    }

    10% {
        transform: translateX(-10px);
    }

    20% {
        transform: translateX(10px);
    }

    30% {
        transform: translateX(-10px);
    }

    40% {
        transform: translateX(10px);
    }

    50% {
        transform: translateX(-10px);
    }

    60% {
        transform: translateX(10px);
    }

    70% {
        transform: translateX(-10px);
    }

    80% {
        transform: translateX(10px);
    }

    90% {
        transform: translateX(-10px);
    }

    100% {
        transform: translateX(0);
    }
}

.renwu {
    position: absolute;
    width: 10%;
    height: 10%;
    background-color: #fa0202;
    border-radius: 50%;
    top: var(--top);
    left: var(--left);
    // opacity: 0.8;
    z-index: 100;

    background-size: 100% 100%;
    /* animation: shake_2 1s infinite; */
    /* animation: shake_2 1s infinite; */
}

.game_describe_boby {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}

.game_describe {
    position: absolute;
    width: 10%;
    height: 10%;
    top: var(--top);
    left: var(--left);
    background-color: #a0272794;

    >img {
        width: 100%;
        height: 100%;
        z-index: 1000;
    }
}
</style>
